import React from "react";

function Success() {
  return (
    <div>
      <h3>Adding card successful!!!</h3>
    </div>
  );
}

export default Success;
